import { about } from '../data/content';

export default function About() {
  return (
    <div className="bg-background min-h-screen">
      {/* Page Header */}
      <div className="bg-gradient-to-br from-primary-dark via-primary to-primary-600 text-white py-20">
        <div className="container-wide">
          <span className="inline-block text-sm font-semibold text-primary-200 uppercase tracking-wider mb-3">
            Our Story
          </span>
          <h1 className="text-4xl md:text-5xl font-bold">About Us</h1>
          <p className="mt-4 text-primary-100 max-w-2xl text-lg">
            A trusted partner in analytical chemistry since 2008.
          </p>
        </div>
      </div>

      {/* Company Intro */}
      <section className="section bg-white">
        <div className="container-narrow">
          <div className="max-w-3xl mx-auto">
            {about.intro.map((paragraph, index) => (
              <p
                key={index}
                className="text-text-light leading-relaxed text-lg mb-6 last:mb-0"
              >
                {paragraph}
              </p>
            ))}
          </div>
        </div>
      </section>

      {/* Leadership */}
      <section className="section bg-gradient-subtle">
        <div className="container-wide">
          <div className="text-center mb-16">
            <span className="inline-block text-sm font-semibold text-primary uppercase tracking-wider mb-3">
              Meet the Team
            </span>
            <h2 className="text-headline text-text">Our Leadership</h2>
          </div>

          <div className="space-y-12">
            {about.leadership.map((leader, index) => (
              <div
                key={index}
                className="card overflow-hidden border border-gray-100"
              >
                {/* Header with image and name */}
                <div className={`flex flex-col ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} items-start`}>
                  {/* Image container - fixed size */}
                  <div className="md:w-72 flex-shrink-0 p-6 md:p-8">
                    <div className="relative">
                      <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-transparent rounded-2xl" />
                      <img
                        src={`/images/${leader.image}`}
                        alt={leader.name}
                        className="w-full h-auto rounded-2xl shadow-soft object-cover relative"
                      />
                    </div>
                  </div>

                  {/* Name, role, and summary */}
                  <div className="flex-1 p-6 md:p-8 md:py-10">
                    <h3 className="text-2xl font-bold text-text mb-1">
                      {leader.name}
                    </h3>
                    <p className="text-primary font-semibold mb-6">
                      {leader.role}
                    </p>
                    {/* First paragraph as summary */}
                    <p className="text-text-light leading-relaxed">
                      {leader.bio[0]}
                    </p>
                  </div>
                </div>

                {/* Extended bio - full width below */}
                {leader.bio.length > 1 && (
                  <div className="px-6 pb-6 md:px-8 md:pb-8 border-t border-gray-100">
                    <div className="pt-6 space-y-4 max-w-4xl">
                      {leader.bio.slice(1).map((paragraph, paraIndex) => (
                        <p
                          key={paraIndex}
                          className="text-text-light leading-relaxed text-sm"
                        >
                          {paragraph}
                        </p>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Laboratory */}
      <section className="section bg-white">
        <div className="container-narrow">
          <div className="text-center mb-12">
            <span className="inline-block text-sm font-semibold text-primary uppercase tracking-wider mb-3">
              Our Facility
            </span>
            <h2 className="text-headline text-text">Our Laboratory</h2>
          </div>

          <div className="space-y-6">
            <p className="text-text-light leading-relaxed">
              {about.laboratory.intro}
            </p>
            <p className="text-text-light leading-relaxed">
              {about.laboratory.equipment}
            </p>
            <div className="card p-6 bg-gradient-to-r from-primary-50 to-primary-100/50 border border-primary-100 mt-8">
              <p className="text-text font-medium text-center">
                {about.laboratory.additionalServices}
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
